import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    address: "Wuse 2, Abuja",
    branch_id: "1",
    branch_name: "Chicken Republic",
    createdAt: "2023-10-23T15:04:21.552Z",
    description: "Our first restaurant in Abuja",
    employeeid: null,
    type_of_branch: "property",
    updatedAt: "2023-10-23T15:04:21.552Z",
    __v: 0,
    _id: "65368b75ddf5e9fe2869fe4f",
  },
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setPropertyName: (state, action) => {
      state.data.branch_name = action.payload;
      console.log(state.data.branch_name)
    },
    setID: (state, action) => {
      state.data._id = action.payload;
    },
  },
});

export const { setPropertyName, setID } = dataSlice.actions;

const dataSliceReducer = dataSlice.reducer;

export default dataSliceReducer;
